/**
 * PlayerPageHeaderSkeleton component export
 */
import PlayerPageHeaderSkeletonContainer from "./PlayerPageHeaderSkeletonContainer";

export default PlayerPageHeaderSkeletonContainer;
